import React from "react";
import { useLocation } from "react-router-dom";

import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import BackButton from "../../UI/BackButton";

import PinInput from "react-pin-input";
import useVerifyEmailApi from "../../Global/Api/VerifyEmail/verifyEmailApi";
import useResendEmailCode from "../../Global/Api/VerifyEmail/resendEmailCode";

export default function VerifyEmail() {
  const location = useLocation();
  const verifyEmailApi = useVerifyEmailApi();
  const resendEmailCodeApi = useResendEmailCode();

    const handleCode = (code) => {
        if (code.length !== 6) return;

        verifyEmailApi.send({
            verify_code: code,
        });
    };

    const email = location?.state?.email;
    const resendCode = () => {
        if (!email) return;

        resendEmailCodeApi.send({
            email,
            business_unit_id: localStorage.getItem("businessId"),
        });
    };

  return (
    <RegisterWrapper image="/assets/images/register-2.svg">
      <BackButton />
      <h1 className="register__title mt20">Verify your email</h1>
      <p className="register__p mt8">
        We’ve sent you verification code, please check your email:{" "}
      </p>
      <p className="register__text mt2">{location?.state.email}</p>

      <div className="register__pin mt28">
        <PinInput
          length={6}
          type="numeric"
          inputMode="number"
          onComplete={(value) => {
            handleCode(value);
          }}
          autoSelect={true}
          regexCriteria={/^[0-9]*$/}
        />
      </div>

      <div className="register__footer mt24">
        Didn’t receive a code?
        {resendEmailCodeApi?.isRunning ? (
          <div className="register__link ml4">{resendEmailCodeApi?.timer}</div>
        ) : (
          <div onClick={resendCode} className="register__link ml4">
            Resend code
          </div>
        )}
      </div>
    </RegisterWrapper>
  );
}
